// Imports
  // React
  import { useState, useEffect } from 'react';
  import { Link } from 'react-router-dom';
  // Firebase
  import { collection, getFirestore, onSnapshot, orderBy, query } from 'firebase/firestore';
  import { useAuth } from '../firebase/FirebaseClient'
  // Components
  import OrderCard from './OrderCard';
  // Icons
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'



// rafce
const OrderList = (  ) => {

  const currentUser = useAuth();

    // useState para que persista
    const [orders, setOrders] = useState([ ]);
    
    // fragmentos de la config del Firebase
    const db = getFirestore ()
    const ordersCollection = collection(db, "orders")
    const q = query(ordersCollection, orderBy("date", "desc"))

    // useEffect para que se ejecute sólo al momento de montar el componente
    useEffect(
      () => 
        onSnapshot(q, (snapshot) =>
          setOrders(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }) ) )
        ),
      []
    );
    

    // Functions
      
      // Mostrar Orders
      function listOrders(){
        // Listar Orders
        return (
          orders.map( o =>
            <div key={o.date}>
              <OrderCard order={o} />
            </div>
          )
        );
      }


      // Scroll to Top
      const scrollToTop = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }




  // Component

  return (
    <div className='main-admin'>
      <div className='main-admin-buttons'>
        <Link to="/admin" style={{alignSelf:"flex-start"}}>
          <FontAwesomeIcon icon={ faRightFromBracket } flip="horizontal" />
        </Link>
      </div>
      { !currentUser ?
        (
          <p>
            Por favor inicie sesión para continuar
          </p>
        )
        :
        <ul className="order-list-container" onLoad={scrollToTop}>
          {
            orders.length
            ?         
            listOrders()
            :
            <span>No hay ningún pedido</span>
          }
        </ul>
      } 
    </div>
  )

}

export default OrderList